/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import {
    object,
} from 'prop-types';
import Data from './ViewData';

const styles = (theme)  => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downSmall,
            margin: '0 auto',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downMedium,
            margin: '0 auto',
        },
        padding: 16,
        letterSpacing: '0.03em',
    },
    headerImage: {
        textAlign: 'center',
    },
    headerTitle: {
        fontSize: 24,
        textAlign: 'center',
    },
    subTitle: {
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 'bold',
        fontStyle: 'italic',
        margin: '10px  0',
    },
    description: {
        fontSize: 14,
        margin: '14px  0',
    },
    bottomLink: {
        color: theme.palette.primary[900],
    },

});

const SympathyFacebookWallPage = ({
    classes,
}) => {
    const {
        HeaderTitle, SubTitle, HeaderImage,
        Description,
    } = Data;
    return (
        <>
            <Grid container className={classes.container}>
                <Grid item xs={12}>
                    <div className={classes.headerTitle}>{HeaderTitle}</div>
                    <Typography className={classes.subTitle}>{SubTitle}</Typography>
                    <div className={classes.headerImage}>
                        <img
                            src={`${HeaderImage}?height=564&width=1094`}
                            alt="Facebook Wall as Condolence Note"
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.description}>{ReactHtmlParser(Description)}</div>
                    <Typography className={classes.description}><strong>A version of this piece originally ran on modernloss.com</strong></Typography>
                    <Link className={classes.bottomLink} to="https://modernloss.com">https://modernloss.com</Link>
                </Grid>
            </Grid>
        </>
    );
};

SympathyFacebookWallPage.propTypes = {
    classes: object.isRequired,
};
export default withStyles(styles)(SympathyFacebookWallPage);
